/* eslint-disable import/prefer-default-export */
import { Metrics } from 'src/utils';
import { MethodName, MetricKeys } from 'src/constants/metrics';
import { useRouter } from 'next/router';
import { pagePathMap } from 'src/constants/pages';

interface StringMetric {
  metricName: string,
  metricValue: string
}
interface CountMetric {
  metricName: string,
  metricValue: number
}
interface ClickMetricProps {
  metricName: string,
  metricValue?: string
  stringMetrics?: Array<StringMetric>
  countMetrics?: Array<CountMetric>
}

interface ChangeMetricProps {
  metricName: string,
  metricValue: string
}

const useMetrics = () => {
  const { pathname } = useRouter();
  const pageName = pagePathMap[pathname];

  const clickMetric = ({
    metricName, metricValue, stringMetrics, countMetrics,
  }: ClickMetricProps): void => {
    const metrics = new Metrics(`${MethodName.userClick}.${pageName}`);
    if (metricValue) {
      metrics.publishString(metricName, metricValue);
      metrics.publishCounterMetric(`${metricName}.${metricValue}`, 1);
    } else {
      metrics.publishString(MetricKeys.button, metricName);
      metrics.publishCounterMetric(metricName, 1);
    }
    if (stringMetrics) {
      stringMetrics.forEach(({ metricName: stringMetricName, metricValue: stringMetricValue }) => {
        metrics.publishString(stringMetricName, stringMetricValue);
      });
    }
    if (countMetrics) {
      countMetrics.forEach(({ metricName: stringMetricName, metricValue: countMetricValue }) => {
        metrics.publishCounterMetric(stringMetricName, countMetricValue);
      });
    }
  };

  const changeMetric = ({
    metricName, metricValue,
  }: ChangeMetricProps): void => {
    const metrics = new Metrics(`${MethodName.userChange}.${pageName}`);
    metrics.publishString(metricName, metricValue);
  };

  return { clickMetric, changeMetric };
};

export default useMetrics;
